window.addEventListener("scroll", (ev) => {
    const scrollPosition = window.scrollY;
    const logoImage = document.querySelectorAll('.pdw-logo');
    logoImage.forEach((logo) => {

        let newSrc = logo.src;

        if (scrollPosition > 0) {
            if (!newSrc.includes('-dark')) {
                newSrc = newSrc.replace('.svg', '-dark.svg');
                logo.src = newSrc;
            }
            document.body.classList.add('scrolled');
            document.getElementById('header').classList.add('active');
        } else {
            if (newSrc.includes('-dark')) {
                newSrc = newSrc.replace('-dark.svg', '.svg');
                logo.src = newSrc;
            }
            document.body.classList.remove('scrolled');
            document.getElementById('header').classList.remove('active');
        }
    });
});
